import { defineAsyncComponent } from 'vue'

export const ModalInstallGooglePlay = defineAsyncComponent(
    () => import('../ModalInstallGooglePlay/ModalInstallGooglePlay.vue'),
)
